

import React, { useState, useRef ,useEffect} from "react";
import YouTube from "react-youtube";

import {Minus,Activity ,ChevronLeft,ChevronUp,ChevronDown,X,Plus ,Phone,Check,Video,
  Play,Pause,UndoDot,RedoDot,Maximize,CircleGauge,Volume1,MessagesSquare,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,BookA,GalleryHorizontal,BadgePlus,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Aperture,BetweenHorizontalStart,
  ImagePlay,Film,NotepadText,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare  } from 'lucide-react';

const YoutubeDefaultPlayer = ({videoSettings, videoId, transcript ,minHeight,maxHeight}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [hoverTime, setHoverTime] = useState(null);
  const [videoTime, setVideoTime] = useState(0);
  const [volume, setVolume] = useState(100);
  const [speed, setSpeed] = useState(1);
  const [qualityLevels, setQualityLevels] = useState([]);
  const [selectedQuality, setSelectedQuality] = useState("");
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  // YouTube Player Options
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [hoverVideo, setHoverVideo] = useState(true);
  const [speedShow, setSpeedShow] = useState(false);
  
  function getYouTubeVideoToken(input) {
    try {
      let url = "";
  
      // If input is an iframe, extract the src attribute
      if (input.startsWith("<iframe")) {
        const srcMatch = input.match(/src="([^"]+)"/);
        if (!srcMatch) {
          throw new Error("No src attribute found in the iframe tag");
        }
        url = srcMatch[1]; // Extract the src URL from the iframe
      } else {
        url = input; // Assume input is already a URL
      }
  
      // Regular expression to extract YouTube video token
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
  
      if (match && match[1]) {
        return match[1]; // The video token
      } else {
        // throw new Error("No video token found in the input");
      }
    } catch (error) {
      // console.error("Error extracting video token:", error.message);
      return null;
    }
  }



  function getYouTubeThumbnail(input) {
    try {
      // Extract video token
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      let videoId;
  
      if (input.startsWith("<iframe")) {
        const srcMatch = input.match(/src="([^"]+)"/);
        if (!srcMatch) {
          throw new Error("No src attribute found in the iframe tag");
        }
        const srcUrl = srcMatch[1];
        const match = srcUrl.match(regex);
        videoId = match ? match[1] : null;
      } else {
        const match = input.match(regex);
        videoId = match ? match[1] : null;
      }
  
      if (!videoId) {
        throw new Error("No video token found");
      }
  
      // Return thumbnail URLs
      return {
        default: `https://img.youtube.com/vi/${videoId}/default.jpg`,
        highQuality: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        mediumQuality: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
        standardDefinition: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
        maxResolution: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      };
    } catch (error) {
      console.error("Error extracting thumbnail:", error.message);
      return null;
    }
  }
  
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.code === "Space") {
  //       handlePlayPause()
  //     }
  //   };
  //   const handleKeyUp = () => { handlePlayPause()}

  //   // Add event listener to the whole document
  //   window.addEventListener("keydown", handleKeyDown);
  //   window.addEventListener("keyup", handleKeyUp);

  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //     window.removeEventListener("keyup", handleKeyUp);
  //   };
  // }, []);
  
  const toggleFullScreen = () => {
    if (!isFullScreen) {
      if (containerRef?.current?.requestFullscreen) {
        containerRef?.current?.requestFullscreen();
      } else if (containerRef?.current?.webkitRequestFullscreen) {
        containerRef?.current?.webkitRequestFullscreen();
      } else if (containerRef?.current?.mozRequestFullScreen) {
        containerRef?.current?.mozRequestFullScreen();
      } else if (containerRef?.current?.msRequestFullscreen) {
        containerRef?.current?.msRequestFullscreen();
      }
      setIsFullScreen(true);
    } else {
      if (document?.exitFullscreen) {
        document?.exitFullscreen();
      } else if (document?.webkitExitFullscreen) {
        document?.webkitExitFullscreen();
      } else if (document?.mozCancelFullScreen) {
        document?.mozCancelFullScreen();
      } else if (document?.msExitFullscreen) {
        document?.msExitFullscreen();
      }
      setIsFullScreen(false);
    }
  };

  const options = {
    height: isFullScreen ? screenHeight : minHeight, // Full screen or default height
    width:  "100%" , // Full screen or default width
    playerVars: {
      autoplay: 0,
      controls: 1, // Hide default controls
    },
  };
      

  const handleReady = (event) => {
    playerRef.current = event.target;
    setDuration(event.target.getDuration());
    setQualityLevels(event.target.getAvailableQualityLevels());
  };

  const handlePlayPause = () => {
    if (isPlaying) {
   
      playerRef.current.pauseVideo();
    } else {
      playerRef.current.playVideo();
    }
    
      if (isPlaying) {
    setTimeout(()=>{
      setIsPlaying(!isPlaying);
    },0)
  }else{
    setTimeout(()=>{
      setIsPlaying(!isPlaying);
    },500)
    }
   
  };

  const handleTimeUpdate = () => {
    const currentTime = playerRef.current.getCurrentTime();
    setProgress((currentTime / duration) * 100);
    setVideoTime(currentTime);
  };

  const handleSliderChange = (e) => {
    const newProgress = e.target.value;
    const newTime = (newProgress / 100) * duration;
    playerRef.current.seekTo(newTime, true);
    setProgress(newProgress);
    setVideoTime(newTime);
  };

  const handleMouseMove = (e) => {
    const sliderRect = sliderRef.current.getBoundingClientRect();
    const hoverPosition = e.clientX - sliderRect.left;
    const hoverPercentage = hoverPosition / sliderRect.width;
    const hoverTime = hoverPercentage * duration;
    setHoverTime(hoverTime);
  };

  const handleMouseLeave = () => setHoverTime(null);

  const handleSkip = (seconds) => {
    const newTime = Math.max(0, Math.min(duration, videoTime + seconds));
    playerRef.current.seekTo(newTime, true);
    setVideoTime(newTime);
    setProgress((newTime / duration) * 100);
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    playerRef.current.setVolume(newVolume);
  };

  const handleSpeedChange = (newSpeed) => {
    // const newSpeed = parseFloat(e.target.value);
    setSpeed(parseFloat(newSpeed));
    playerRef.current.setPlaybackRate(parseFloat(newSpeed));
  };

  const handleQualityChange = (e) => {
    const quality = e.target.value;
    setSelectedQuality(quality);
    playerRef.current.setPlaybackQuality(quality);
  };

  

  // YouTube onStateChange Event
  const handleStateChange = (event) => {
    const state = event.data;
    if (state === 1) {
      // Video is playing
      // setIsPlaying(true);
      intervalRef.current = setInterval(() => {
        handleTimeUpdate();
      }, 500); // Update time every 500ms
    } else { handlePlayPause()
      // Videois paused or stopped
      // setIsPlaying(false);
      clearInterval(intervalRef.current);
    }
  };

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

// Format time in HH:MM:SS
const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${hrs > 0 ? `${hrs}:` : ""}${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

const outerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height:  isFullScreen ? screenHeight-60 : minHeight+30, // Full viewport height
    width: "100%", // Full viewport width
    position: "relative", // Ensure the outer div spans the full space
    backgroundColor: "transparent", // Optional background for visibility
  };
 const innerStyleTwo= {
  position:"relative",
    border:"7px solid rgba(256, 256, 256, 0.50302)", // Optional background for visibility
    color: "white",
    padding: "20px",borderRadius:`${videoSettings?.videoPlayButton?.playButtonBorderRadius?.value}px`,
    width: "50px", // Adjust as needed
    height: "50px", // Adjust as needed
   
  };
  const innerStyle = { display: "flex",
    justifyContent: "center",
    alignItems: "center",textAlign: "center",cursor:"pointer",
    padding: "20px",borderRadius:`${videoSettings?.videoPlayButton?.playButtonBorderRadius?.value}px`,
    width: "50px", // Adjust as needed
    height: "50px", // Adjust as needed
    background: `${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.color:"#222222"}`, // Optional background for visibility
    
  };
  return (
    <div ref={containerRef} style={{   width: "100%", // Full width
        margin: "0 auto",overflow:"hidden",position:"relative" ,minHeight:minHeight+"px",maxHeight:maxHeight+"px"}}>
        {/* <div style={{position:"absolute",height:"80px",background:"transparent",top:"0px",left:"0px",right:"0px"}}></div> */}
         {!isPlaying ?<div align="center" style={{position:"absolute",background:!videoSettings?.videoThumbnail?.hideThumbnail?"#000":"",top:"0px",
          bottom:"0px",left:"0px",right:"0px",zIndex:"99999999"}}>
{/*        
        {
  default: "https://img.youtube.com/vi/flyaWBnDt4Q/default.jpg",
  highQuality: "https://img.youtube.com/vi/flyaWBnDt4Q/hqdefault.jpg",
  mediumQuality: "https://img.youtube.com/vi/flyaWBnDt4Q/mqdefault.jpg",
  standardDefinition: "https://img.youtube.com/vi/flyaWBnDt4Q/sddefault.jpg",
  maxResolution: "https://img.youtube.com/vi/flyaWBnDt4Q/maxresdefault.jpg"
}
        */}
        {!videoSettings?.videoThumbnail?.hideThumbnail?videoSettings?.youtube?.showDefaultThumbnail?<img src={getYouTubeThumbnail(videoId)?.maxResolution} 
        style={{height: isFullScreen ? screenHeight : "",width:isFullScreen ? "" :"100%"}}/>:<img src={videoSettings?.videoThumbnail?.src} 
        style={{height: isFullScreen ? screenHeight : "",width:isFullScreen ? "" :"100%"}}/>:<div style={{height: isFullScreen ? screenHeight : "",width:isFullScreen ? "" :"100%"}}></div>}
        <div style={{position:"absolute",height:"70px",background:"transparent",
          top:"-12%",bottom:"0px",left:"0%",right:"0px"}}>
            <div style={outerStyle}>
            {duration?<div onClick={handlePlayPause}  style={innerStyle}> 
      <div className="innerStyleTwoPlayOuter" style={innerStyleTwo}> 
      <div className="innerStyleTwoPlay" ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px"}}  color="#fff"/>
          </div>
          </div>:<div   style={innerStyle}> 
      <div  style={innerStyleTwo}> 
      <div className="innerStyleTwoPlay" ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px"}}  color="#fff"/>
          </div>
          </div>}
          <div style={{position:"absolute",height:"79px",background:"#222",
          width:"177px",top:"70%",borderRadius:"25px",padding:"0px"}}>
   <div style={{display: "flex",
    gap: "1px", justifyContent: "center", alignItems: "center" ,padding:"10px"}}><Timer strokeWidth={3}  size={20}   color="#fff"/>
    <span style={{fontSize:"18px",fontWeight:"900",color:"#fff",paddingLeft:"15px"}}> <span style={{fontSize:"18px",color:`${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.colors?.color10:"#222222"}`}}>{speed}</span>x </span> 
 </div>  
 <div style={{position:"absolute",height:"39px",background:"#333",
          width:"94%",borderBottomLeftRadius:"25px",borderBottomRightRadius:"25px",borderTopLeftRadius:"5px"
          ,borderTopRightRadius:"5px"
          ,padding:"0px",marginLeft:"5px",marginRight:"5px",marginBottom:"5px",bottom:"0px"}}>
 <div style={{display: "flex",
    gap: "1px", justifyContent: "center", alignItems: "center" ,padding:"10px"}}>
       <span style={{fontSize:"16px",fontWeight:"900",color:"#fff",paddingLeft:"15px"}}> 
       {duration?<span style={{fontSize:"18px",color:`${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.colors?.color10:"#222222"}`}}> {videoTime?formatTime(videoTime)+" / ":"Duration: "} </span> :""} {duration?formatTime(duration):"Video is Not Ready."} </span> 
 </div> 
          </div>
          </div>
    </div>
    
          </div>
        
        </div>:""}
        
        <YouTube
        videoId={getYouTubeVideoToken(videoId)}
        opts={options}
        onReady={handleReady}
        onStateChange={handleStateChange}
      />
      
    <style>{
 `.slider-container {
  width: 99%; 
  margin-top: -11px !important;
  text-align: center;
}.slider-container-volume {
  width: 90px;margin-top: 10px;
  
  text-align: center;
}
  .innerStyleTwoPlayOuter:hover{background:${videoSettings?.videoPlayButton?.playButtonColor?.hover?.color?videoSettings?.videoPlayButton?.playButtonColor?.hover?.color:"#fff"} !important; }
.innerStyleTwoPlay{animation: PlayButtonAnim 2.8s infinite linear;
  border:7px solid rgba(256, 256, 256, 0.50302);
  position: absolute;top:0px;left:0px;right:0px;bottom: 0px;
  padding: 20px;border-radius:${videoSettings?.videoPlayButton?.playButtonBorderRadius?.value}px;
  width: 35px; 
  height: 35px;}
@keyframes PlayButtonAnim{
  0% {
      /* opacity: 0; */
      transform: scale(1.4)
  }
  50% {
      transform: scale(0.81)
  }
 
  100% {
      transform: scale(1.4)
  }
  }

  .btnPlayerCircleHover{border-radius:50%;width:35px;height:35px;border:2px solid transparent}
  .btnPlayerCircleHover:hover{border-radius:50%;;background:#222;border:2px solid transparent}
  .btnPlayerSquareHover{border-radius:25%;border:2px solid transparent}
.btnPlayerSquareHover:hover{border-radius:25%;;background:#222;border:2px solid transparent}
.video-player-custom-slider {
  -webkit-appearance: none; /* Remove default slider styles */
  appearance: none;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.color:"#222222"},  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.color:"#222222"});;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}
.video-player-custom-slider-volume {
  -webkit-appearance: none; /* Remove default slider styles */
  appearance: none;
  width: 100%;
  height: 9px;
  background: linear-gradient(90deg, #f1f1f1, #fff);
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}
.video-player-custom-slider:hover {
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.hover?.color?videoSettings?.videoPlayButton?.playButtonColor?.hover?.color:"#222222"}';
}

/* Custom Thumb */
.video-player-custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color?videoSettings?.videoPlayButton?.playButtonColor?.normal?.color:"#222222"};
  border-radius: 50%;
  border: 2px solid #fff;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.video-player-custom-slider::-moz-range-thumb {
  width: 10px;
  height: 10px;
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
  border-radius: 50%;
  border: 2px solid #fff;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Hover and Active States */
.video-player-custom-slider::-webkit-slider-thumb:hover {
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
}

.video-player-custom-slider::-webkit-slider-thumb:active {
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
}




.video-player-custom-slider-volume::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
  border-radius: 50%;
  border: 2px solid #fff;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.video-player-custom-slider-volume::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
  border-radius: 50%;
  border: 2px solid #fff;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Hover and Active States */
.video-player-custom-slider-volume::-webkit-slider-thumb:hover {
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
}

.video-player-custom-slider-volume::-webkit-slider-thumb:active {
  background:  ${videoSettings?.videoPlayButton?.playButtonColor?.normal?.color};
}


 /* lg */ 
 @media (min-width: 1200px) {

 }
 /* md */
 @media (min-width: 992px) and (max-width: 1199px) {
 }
  /* sm */
@media (min-width: 768px) and (max-width: 991px) {

}
 /* xs */
@media (max-width: 767px) {
  .hideMessageBtnnXs{display: none !important;}
   } `}</style>
    </div>
  );
  
};



export default YoutubeDefaultPlayer;







